import { ReactComponent as SmartSignLogoSvg } from './smartsign-logo.svg';

// The SmartSign app mark. Bundled into the JS (no separate network request), so
// it renders with the view instead of popping in late — the same reason
// MessageSentImage inlines its illustration.
//
// The mark carries its own navy ground and rounded corners, so it needs no tile
// behind it; `size` sets both dimensions and the corner radius follows the
// artwork's own 16/64. The backend's emails and sender-verify pages draw this
// same file, which is the point — a signer meets one mark across all three.
export default function SmartSignLogo({ size = 32, className, ...props }) {
  return (
    <SmartSignLogoSvg
      role='img'
      aria-label='SmartSign'
      width={size}
      height={size}
      className={className}
      style={{ borderRadius: Math.round(size * 0.25), flexShrink: 0 }}
      {...props}
    />
  );
}
